import { ContactPage } from '../Contact'

export const CommunalMachineBuyPage = ContactPage